import { HttpClientModule, HttpClient } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { AuthModule, LogLevel, OidcConfigService, OidcSecurityService } from 'angular-auth-oidc-client';
import { AppComponent } from './app.component';
import { routing } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';

//Material
import { MaterialModule } from '../app/material.module';

//Components
import { AutoLoginComponent } from '../components/auto-login/auto-login.component';
import { ForbiddenComponent } from '../components/forbidden/forbidden.component';
import { UnauthorizedComponent } from '../components/unauthorized/unauthorized.component';
import { NavComponent } from '../components/nav/nav.component';
import { FormComponent } from '../components/form/form.component';
import { ConfirmDialogComponent } from '../components/confirm-dialog/confirm-dialog.component';
import { HomeComponent } from '../components/home/home.component';
import { FileUploadComponent } from '../components/file-upload/file-upload.component';

//i18n

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { environment } from 'src/environments/environment';





export function configureAuth(oidcConfigService: OidcConfigService) {
    return () =>
        oidcConfigService.withConfig({
            stsServer: environment.url_audaces_id,
            redirectUrl: environment.callback_url,
            clientId: environment.audaces_id_key,
            responseType: 'id_token token',
            scope: 'openid email profile',
            triggerAuthorizationResultEvent: true,
            postLogoutRedirectUri: '/home',
            startCheckSession: false,
            silentRenew: false,
            silentRenewUrl: window.location.origin + '/silent-renew.html',
            postLoginRoute: '/home',
            forbiddenRoute: '/forbidden',
            unauthorizedRoute: '/unauthorized',
            // logLevel: LogLevel.None,
            historyCleanupOff: true,
        });
}

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        routing,
        HttpClientModule,
        AuthModule.forRoot(),
        BrowserAnimationsModule,
        MaterialModule,
        ToastrModule.forRoot({
            positionClass: 'toast-bottom-right',
          }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],

    declarations: [
        AppComponent,
        HomeComponent,
        ForbiddenComponent,
        UnauthorizedComponent,
        AutoLoginComponent,
        NavComponent,
        FormComponent,
        ConfirmDialogComponent,
        FileUploadComponent
    ],
    providers: [
        OidcSecurityService,
        OidcConfigService,
        {
            provide: APP_INITIALIZER,
            useFactory: configureAuth,
            deps: [OidcConfigService],
            multi: true,
        },
    ],
    bootstrap: [AppComponent],
})
export class AppModule { }
